import React from 'react';
import ReactTable from "react-table";

import moment from 'moment';
import DatePicker from 'react-datepicker';

import { TableComponent, connect } from '../tableComponent'

class Component extends TableComponent {

  apiPath = "affiliate/earnings"

  makeColumns = () => {
    const columns = [
      {
        Header: "Delete",
        accessor: "aid",
        minWidth: 80
      }, {
        Header: "Sale_id",
        accessor: "chatsales_earnings",
        minWidth: 80,
        Cell: props => <input 
          class="form-control form-control-sm"
          type="number" 
          value={props.original.chatsales_earnings}
          onChange={e => {this.handleChangeData(e.target.value,props)}}            
          />
      }, {
        Header: "KLink",
        accessor: "name"
      },
      {
        Header: "Quibids",
        accessor: "email"
      },
      {
        Header: "Smsid",
        accessor: "today",
        Cell: props => <div>{props.original.today_sales} sales / $ {props.value}</div>
      },
      {
        Header: "Date",
        accessor: "yesterday",
        Cell: props => <div>{props.original.yesterday_sales} sales / $ {props.value}</div>
      },
      {
        Header: "Sub-affiliate",
        accessor: "lastWeek",
        Cell: props => <div>{props.original["7_days_sales"]} sales / $ {props.value}</div>
      },
      {
        Header: "Earned",
        accessor: "between",
        Cell: props => <div>{props.original.between_sales} sales / $ {props.value}</div>
      }
    ]   
    return columns; 
  }

  fetchParams = () => {
    return {
      wid: this.locationQuery.wid
    }
  }

  tableParams = {
    manual: true
  }

  render() {
    return (
      <div class="box">
        {this.reactTable()}
      </div>
    );
  }
}

export default connect(Component,"affiliate_earnings")